MesureValidator.$inject = ['validator'];

export default function MesureValidator(validator) {
    const instance = new validator();
    return instance;
}
